import { useMutation, useQuery } from "react-query";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import reject from "lodash/reject";

import { gwtClient } from "@monta/utils";

import type { QueryKey } from "react-query";
import type { PostRateInsert } from "./submit-rate.types";

export const postRateInsert = {
  url: () => `/exam/rateInsertOrUpdate`,
  fn: async (request: PostRateInsert["request"]) => {
    const { data } = await gwtClient<PostRateInsert["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: postRateInsert.url(),
      data: request.body
    });
    return data;
  },
  key: (request: PostRateInsert["request"]) => {
    return reject(
      [postRateInsert.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: PostRateInsert["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: postRateInsert.key(options.request),
    queryFn: () => postRateInsert.fn(options.request)
  }),
  useQuery: (options: PostRateInsert["queryOptions"]) =>
    useQuery(postRateInsert.query(options)),
  useMutation: (options?: PostRateInsert["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: postRateInsert.fn
    })
};
